module.exports = __webpack_public_path__ + "img/security.c724d6a9.svg";